import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number };

const dataQuery = `
  select
    utm_campaign as name,
    count(distinct session_id) as value,
  from events where type = 'span' and label = 'article'
  and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
  group by utm_campaign,
  having value > 10
  and utm_campaign is not null
  order by value desc
`;

const extractUsersQuery = `
  select distinct user_id
  from events where type = 'span'
  and utm_campaign = ?
  and user_id is not null
`

export function CampaignTrafficChart() {
  return <SqlDataTable
    label="Campaign Traffic"
    subtext="Users who visited articles from a campaign. (Last 7 days)"
    width={1200}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Includes only the users who interacted with the <b>{data.name}</b> campaign.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.name])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}